import { IEntityMetaData, IPropretyAttribute } from "../../_models/IEntityMetaData";
import { GenericEntityBase, KeyType } from "../../_models/GenericEntityBase";
import { PropretyAttributes, Validation, NestedProperty, NavigationProperty } from "../../decorators/EntityDecorators";
import { PointOfService } from "./PointOfService.model";
import { Account } from "../matwins-manager/Account.model";
import { EmployeePresenceInstance } from "./EmployeePresenceInstance.model";
import { EmployeePresenceTemplate_Employee } from "./navigation-entities/EmployeePresenceTemplate_Employee.model";


export class EmployeePresenceTemplate extends GenericEntityBase<number> {
  @PropretyAttributes({
    attributes: [
      IPropretyAttribute.KeyProperty,
      IPropretyAttribute.Readonly
    ]
  })
  id: number = GenericEntityBase.GetDefaultId(KeyType.number);

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  @Validation({ maxLength: 255 })
  title!: string;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  fK_PointOfService!: number;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  startDate!: Date;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  endDate!: Date;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  instanceOffset!: number;

  description?: string;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  @Validation({ maxLength: 255 })
  requester!: string;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  iD_SP!: number;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  status!: number;

  availableSeatsNumber?: number;

  noSeatAvailableMessage?: string;

  totalCapacity?: number;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  secured!: boolean;

  fK_Owner?: number;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  creationHour!: number;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  timeZone!: number;

  holidays?: string;

  runningDays?: string;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  continuousNotification!: boolean;

  fK_CoOwner?: number;

  @NestedProperty({ TargetType: PointOfService })
  pointOfService?: PointOfService;

  @NestedProperty({ TargetType: Account })
  owner?: Account;

  @NestedProperty({ TargetType: Account })
  coOwner?: Account;

  @NavigationProperty({ TargetType: EmployeePresenceInstance })
  presenceInstances?: EmployeePresenceInstance[];

  @NavigationProperty({ TargetType: EmployeePresenceTemplate_Employee })
  templateEmployees?: EmployeePresenceTemplate_Employee[];

  GetType(): IEntityMetaData {
    return EmployeePresenceTemplate.getMetaData();
  }
}
